/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function SearchSheetRowHierarchyRequestNumberColumnDataFromJSON(json) {
    return SearchSheetRowHierarchyRequestNumberColumnDataFromJSONTyped(json, false);
}
export function SearchSheetRowHierarchyRequestNumberColumnDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        accountTagId: !exists(json, 'accountTagId') ? undefined : json['accountTagId'],
        dimensionTagIds: !exists(json, 'dimensionTagIds') ? undefined : json['dimensionTagIds'],
    };
}
export function SearchSheetRowHierarchyRequestNumberColumnDataToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        accountTagId: value.accountTagId,
        dimensionTagIds: value.dimensionTagIds,
    };
}
